import React from 'react'

import { components } from 'react-select'
import { observer } from 'mobx-react'

export default observer(({ resource, disabled, innerProps, setPage }) => {
  return (
    <components.Option {...innerProps}>
      <button
        onClick={e => {
          e.stopPropagation()
          setPage(prev => prev + 1)
        }}
        disabled={disabled}
        style={{
          width: '100%',
          background: 'none',
          border: 'none',
          padding: '10px',
          cursor: 'pointer',
        }}
      >
        {resource.ShowMore}
      </button>
    </components.Option>
  )
})
